<template>
    <div class="wrap">
        <listHeader
            :title="postData.empid > 0 ? '编辑员工' : '新增员工'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="employee"
                active="info"
                :empid="postData.empid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="员工名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入员工名称" v-decorator="['name', {rules: [{ required: true, max: 16, message: '请输入员工名称' }], initialValue: ''}]"/>
                            </a-form-item>


                            <a-form-item
                                label="手机号"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请填写人员手机号"
                                         v-decorator="['mobile', {rules: [{ required: true, validator: requiredMobile,  message: '请填写正确的手机号' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="身份证"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请填写人员身份证"
                                         v-decorator="['idcard', {rules: [{ required: true, validator: requiredIdcard,  message: '请填写正确的身份证号码' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="招聘经理"
                                v-bind="formItemLayout"
                            >
                                <a-select
                                    v-decorator="['mid', {required: true, rules: [{ message: '选择招聘经理' }], initialValue: ''}]">>
                                    <a-select-option value="">选择招聘经理</a-select-option>
                                    <template v-for="(item, key) in config.manager">
                                        <a-select-option :key="key" :value="item[0]" v-if="item[0].charAt(0) != 'G'">
                                            {{ item[1] }}
                                        </a-select-option>
                                        <a-select-option v-else :key="key" :value="item[0]" :disabled="true">
                                            {{ item[1] }}
                                        </a-select-option>
                                    </template>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="供应商"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="请输入供应商" v-decorator="['supname', {rules: [{ required: false, max: 32, message: '请输入供应商' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="入职日期"
                                v-bind="formItemLayout"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择入职日期"
                                    v-decorator="['jointime',{rules: [{ required: false, message: '请选择入职日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="离职日期"
                                v-bind="formItemLayout"
                                v-if="!postData.eid"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择离职日期"
                                    v-decorator="['departuretime',{rules: [{ required: false, message: '请选择离职日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="合同开始"
                                v-bind="formItemLayout"
                                v-if="!postData.empid"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择合同开始日期"
                                    v-decorator="['scontract',{rules: [{ required: false, message: '请选择合同开始日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="合同结束"
                                v-bind="formItemLayout"
                                v-if="!postData.empid"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择合同结束日期"
                                    v-decorator="['econtract',{rules: [{ required: false, message: '请选择合同结束日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="附加信息"
                                v-bind="formItemLayout"
                            >
                                <a-textarea
                                    v-decorator="['content',{rules: [{ required: false, message: '请输入员工扩展信息' }]} ]"
                                    placeholder="请输入员工扩展信息，格式如：学历:本科，多条信息换行输入"
                                    :auto-size="{ minRows: 3 }"
                                />
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import hroTab from '@/components/list/tab';
import moment from "moment";

export default {
    components: {
        listHeader,
        hroTab,
    },
    data() {
        return {
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'jid': '',
                'empid': '',
            },
            data: {},
            config: {},
            dateFormat: 'YYYY-MM-DD',
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/employee/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.empid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            name: res.data.name,
                            idcard: res.data.idcard,
                            mobile: res.data.mobile,
                            mid: res.data.muid,
                            supname: res.data.supname,
                            jointime: res.data.jointime != '0' ? moment(res.data.jointime_str, this.dateFormat) : null,
                            departuretime: res.data.departuretime != '0' ? moment(res.data.departuretime_str, this.dateFormat) : null,
                            content: res.data.content,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.empid > 0) {
                            url = '/manage/employee/edit';

                            values.empid = this.postData.empid;
                        } else {
                            url = '/manage/employee/save';

                            values.jid = this.postData.jid;
                        }

                        values.jointime = values.jointime ? values.jointime.format(this.dateFormat) : '';
                        values.departuretime = values.departuretime ? values.departuretime.format(this.dateFormat) : '';
                        values.scontract = values.scontract ? values.scontract.format(this.dateFormat) : '';
                        values.econtract = values.econtract ? values.econtract.format(this.dateFormat) : '';

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.empid == '') {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
